var exports = {
  "z": "x620889e6--e2c954--root",
  "h": "x620889e6--e2c954--description",
};

module.exports = exports;
